export default __webpack_public_path__ + "static/media/pepper_back.6d9d784f.png";